export enum InfiniteScrollWay {
    CLICK = 1,
    PAGINATION = 2
}